//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root' 
})
export class AuthorizationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Authorization
     * @return Token
     */
    exchange(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/connect/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExchange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExchange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExchange(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
  providedIn: 'root' 
})
export class ConversationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Conversations
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    getConversations(isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetConversationsResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Conversations/all?";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConversations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConversationsResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConversationsResponseModel>;
        }));
    }

    protected processGetConversations(response: HttpResponseBase): Observable<GetConversationsResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConversationsResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Conversaton By Id
     */
    getConversationById(id: string): Observable<GetConversationByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Conversations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConversationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConversationByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConversationByIdResponseModel>;
        }));
    }

    protected processGetConversationById(response: HttpResponseBase): Observable<GetConversationByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConversationByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiate Conversation By ChatId
     */
    initiateConversation(chatId: string): Observable<InitializeConversationResponseModel> {
        let url_ = this.baseUrl + "/api/v1/Conversations/initiate/{chatId}";
        if (chatId === undefined || chatId === null)
            throw new globalThis.Error("The parameter 'chatId' must be defined.");
        url_ = url_.replace("{chatId}", encodeURIComponent("" + chatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InitializeConversationResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InitializeConversationResponseModel>;
        }));
    }

    protected processInitiateConversation(response: HttpResponseBase): Observable<InitializeConversationResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitializeConversationResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
  providedIn: 'root' 
})
export class MessagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Messages of the selected Conversation
     * @param conversationId (optional) 
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    getMessages(conversationId: string | null | undefined, isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetMessageResponseModel> {
        let url_ = this.baseUrl + "/api/v1/messages?";
        if (conversationId !== undefined && conversationId !== null)
            url_ += "ConversationId=" + encodeURIComponent("" + conversationId) + "&";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMessageResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMessageResponseModel>;
        }));
    }

    protected processGetMessages(response: HttpResponseBase): Observable<GetMessageResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessageResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Total Count of Unread Messages the user has
     * @param model (optional) 
     */
    getUnreadMessages(model: GetUnreadMessageRequestModel | null | undefined): Observable<GetUnreadMessageResponseModel> {
        let url_ = this.baseUrl + "/api/v1/messages/unread?";
        if (model !== undefined && model !== null)
            url_ += "model=" + encodeURIComponent("" + model) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUnreadMessageResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUnreadMessageResponseModel>;
        }));
    }

    protected processGetUnreadMessages(response: HttpResponseBase): Observable<GetUnreadMessageResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnreadMessageResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
  providedIn: 'root' 
})
export class SignUpClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Register new User
     * @return Confirmation Message
     */
    registerUser(model: RegisterUserRequestModel): Observable<RegisterUserResponseModel> {
        let url_ = this.baseUrl + "/signup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterUserResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterUserResponseModel>;
        }));
    }

    protected processRegisterUser(response: HttpResponseBase): Observable<RegisterUserResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterUserResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
  providedIn: 'root' 
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://localhost:5001";
    }

    /**
     * Get Users
     * @param isHideCount (optional) 
     * @param search (optional) 
     * @param isDescending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param orderBy (optional) 
     */
    getUsers(isHideCount: boolean | undefined, search: string | null | undefined, isDescending: boolean | undefined, page: number | undefined, pageSize: number | undefined, orderBy: string | null | undefined): Observable<GetUsersResponseModel> {
        let url_ = this.baseUrl + "/api/v1/users?";
        if (isHideCount === null)
            throw new globalThis.Error("The parameter 'isHideCount' cannot be null.");
        else if (isHideCount !== undefined)
            url_ += "IsHideCount=" + encodeURIComponent("" + isHideCount) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUsersResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUsersResponseModel>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<GetUsersResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUsersResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User By Id
     */
    getUserById(id: string): Observable<GetUserByIdResponseModel> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserByIdResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserByIdResponseModel>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<GetUserByIdResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserByIdResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class GetConversationsResponseModel implements IGetConversationsResponseModel {
    data?: ConversationDto[] | undefined;
    count?: number;

    constructor(data?: IGetConversationsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConversationDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetConversationsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetConversationsResponseModel {
    data?: ConversationDto[] | undefined;
    count?: number;
}

export class ConversationDto implements IConversationDto {
    conversationId?: string | undefined;
    user1?: string | undefined;
    user2?: string | undefined;
    otherUser?: UsersDto | undefined;
    lastMessageTime?: Date;
    lastMessageSnippet?: string | undefined;
    unreadCount?: number;
    createdDate?: Date;

    constructor(data?: IConversationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"];
            this.user1 = _data["user1"];
            this.user2 = _data["user2"];
            this.otherUser = _data["otherUser"] ? UsersDto.fromJS(_data["otherUser"]) : undefined as any;
            this.lastMessageTime = _data["lastMessageTime"] ? new Date(_data["lastMessageTime"].toString()) : undefined as any;
            this.lastMessageSnippet = _data["lastMessageSnippet"];
            this.unreadCount = _data["unreadCount"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConversationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId;
        data["user1"] = this.user1;
        data["user2"] = this.user2;
        data["otherUser"] = this.otherUser ? this.otherUser.toJSON() : undefined as any;
        data["lastMessageTime"] = this.lastMessageTime ? this.lastMessageTime.toISOString() : undefined as any;
        data["lastMessageSnippet"] = this.lastMessageSnippet;
        data["unreadCount"] = this.unreadCount;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IConversationDto {
    conversationId?: string | undefined;
    user1?: string | undefined;
    user2?: string | undefined;
    otherUser?: UsersDto | undefined;
    lastMessageTime?: Date;
    lastMessageSnippet?: string | undefined;
    unreadCount?: number;
    createdDate?: Date;
}

export class UsersDto implements IUsersDto {
    chatId?: string | undefined;
    name?: string | undefined;
    userName?: string | undefined;
    status?: string | undefined;
    lastSeen?: Date;
    createdDate?: Date;

    constructor(data?: IUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatId = _data["chatId"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.status = _data["status"];
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatId"] = this.chatId;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["status"] = this.status;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUsersDto {
    chatId?: string | undefined;
    name?: string | undefined;
    userName?: string | undefined;
    status?: string | undefined;
    lastSeen?: Date;
    createdDate?: Date;
}

export class GetConversationByIdResponseModel implements IGetConversationByIdResponseModel {
    data?: ConversationDetailDto | undefined;

    constructor(data?: IGetConversationByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ConversationDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetConversationByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetConversationByIdResponseModel {
    data?: ConversationDetailDto | undefined;
}

export class ConversationDetailDto extends ConversationDto implements IConversationDetailDto {

    constructor(data?: IConversationDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ConversationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IConversationDetailDto extends IConversationDto {
}

export class InitializeConversationResponseModel implements IInitializeConversationResponseModel {
    data?: ConversationDto | undefined;

    constructor(data?: IInitializeConversationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ConversationDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): InitializeConversationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InitializeConversationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IInitializeConversationResponseModel {
    data?: ConversationDto | undefined;
}

export class GetMessageResponseModel implements IGetMessageResponseModel {
    data?: MessagesDto[] | undefined;
    count?: number;

    constructor(data?: IGetMessageResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MessagesDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetMessageResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetMessageResponseModel {
    data?: MessagesDto[] | undefined;
    count?: number;
}

export class MessagesDto implements IMessagesDto {
    id?: string | undefined;
    conversationId?: string | undefined;
    senderId?: string | undefined;
    receiverId?: string | undefined;
    messageContent?: string | undefined;
    status?: MessageStatus;
    sentTime?: Date;
    deliveredTime?: Date | undefined;
    readTime?: Date | undefined;

    constructor(data?: IMessagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conversationId = _data["conversationId"];
            this.senderId = _data["senderId"];
            this.receiverId = _data["receiverId"];
            this.messageContent = _data["messageContent"];
            this.status = _data["status"];
            this.sentTime = _data["sentTime"] ? new Date(_data["sentTime"].toString()) : undefined as any;
            this.deliveredTime = _data["deliveredTime"] ? new Date(_data["deliveredTime"].toString()) : undefined as any;
            this.readTime = _data["readTime"] ? new Date(_data["readTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MessagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conversationId"] = this.conversationId;
        data["senderId"] = this.senderId;
        data["receiverId"] = this.receiverId;
        data["messageContent"] = this.messageContent;
        data["status"] = this.status;
        data["sentTime"] = this.sentTime ? this.sentTime.toISOString() : undefined as any;
        data["deliveredTime"] = this.deliveredTime ? this.deliveredTime.toISOString() : undefined as any;
        data["readTime"] = this.readTime ? this.readTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IMessagesDto {
    id?: string | undefined;
    conversationId?: string | undefined;
    senderId?: string | undefined;
    receiverId?: string | undefined;
    messageContent?: string | undefined;
    status?: MessageStatus;
    sentTime?: Date;
    deliveredTime?: Date | undefined;
    readTime?: Date | undefined;
}

export enum MessageStatus {
    Sent = 0,
    Delivered = 1,
    Read = 2,
}

export class GetUnreadMessageResponseModel implements IGetUnreadMessageResponseModel {
    count?: number;

    constructor(data?: IGetUnreadMessageResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetUnreadMessageResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnreadMessageResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IGetUnreadMessageResponseModel {
    count?: number;
}

export class GetUnreadMessageRequestModel implements IGetUnreadMessageRequestModel {

    constructor(data?: IGetUnreadMessageRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUnreadMessageRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnreadMessageRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUnreadMessageRequestModel {
}

export class RegisterUserResponseModel implements IRegisterUserResponseModel {
    data?: UsersDto | undefined;

    constructor(data?: IRegisterUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UsersDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegisterUserResponseModel {
    data?: UsersDto | undefined;
}

export class RegisterUserRequestModel implements IRegisterUserRequestModel {
    userName?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IRegisterUserRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): RegisterUserRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["status"] = this.status;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IRegisterUserRequestModel {
    userName?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
}

export class GetUsersResponseModel implements IGetUsersResponseModel {
    data?: UsersDto[] | undefined;
    count?: number;
  pagination: any;

    constructor(data?: IGetUsersResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UsersDto.fromJS(item));
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): GetUsersResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IGetUsersResponseModel {
    data?: UsersDto[] | undefined;
    count?: number;
}

export class GetUserByIdResponseModel implements IGetUserByIdResponseModel {
    data?: UsersDetailDto | undefined;

    constructor(data?: IGetUserByIdResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UsersDetailDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUserByIdResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserByIdResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUserByIdResponseModel {
    data?: UsersDetailDto | undefined;
}

export class UsersDetailDto extends UsersDto implements IUsersDetailDto {

    constructor(data?: IUsersDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UsersDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUsersDetailDto extends IUsersDto {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}